export function capitalizeFirstLetter(val: String): string {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}